module.exports = "<div class=\"mytimesheet\">\n  <app-intelcia-accordin [agent]=\"_agent\" [useExport]=\"false\"></app-intelcia-accordin>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/mytimesheet/mytimesheet.component.html
// module id = ./src/app/view/mytimesheet/mytimesheet.component.html
// module chunks = main